import moment from 'moment-timezone';
import { getState } from 'pluginServices/store';
import { selectCurrentMe } from 'data/CurrentUser/selectors';
import { selectedProject } from 'Workspace/Projects/store/selectors';
import workspaceService from 'services/WorkspaceService';
import projectService from 'services/ProjectService';
import { PermissionTypes } from 'constants/enums';
import featureFlagService, { featureKeys } from 'services/FeatureFlagService';
import { getCornucopiaScreenPath } from 'builder/Pathway/components/ScreenEditor/Cornucopia/helpers';
import { ETEXT_COURSE_PLUGIN_ID } from 'builder/Pathway/components/ScreenEditor/Cornucopia/constants';
import { PLUGIN_TYPE_LESSON } from 'pluginServices/manifest/constants';

const { OWNER, CONTRIBUTOR } = PermissionTypes;

/**
 * Get elapsed time based on format
 * -UUID
 * -Date
 * @param {string} timeStamp
 * @param {string} format
 */
export const getTime = (timeStamp, format) => moment(new Date(timeStamp)).format(format);

export const getSelectedProject = () => selectedProject(getState());

export const getCurrentUser = () => selectCurrentMe(getState());

/**
 * Accepts project instance and return permission level
 * @param {Object} project
 * @returns {String | null}
 */
export const getUserPermissionLevel = ({ permissionLevel }) => {
  const currentUser = getCurrentUser();
  if (permissionLevel && currentUser) {
    return permissionLevel;
  }
  return null;
};

/**
 * get All user projects with certain level of permissions
 * default levels are CONTRIBUTOR, OWNER
 * @param {Array} allowedPermissionLevels
 * @return {Array}
 */
export const getUserProjects = async (allowedPermissionLevels = [CONTRIBUTOR, OWNER]) => {
  const workspaceId = await workspaceService.getSelectedWorkspaceId();
  const projects = await projectService.getProjectsList(workspaceId);
  // get productId from breadcrumb.ok
  return projects.filter((project) => {
    if (allowedPermissionLevels.includes(getUserPermissionLevel(project))) {
      return project;
    }
    return null;
  });
};

export const getActivityPath = async (activity) => {
  const { plugin, activityId } = activity;
  const isActivityEditorEnabled = featureFlagService.is(featureKeys.WORKSPACE_AUTHORING_ACTIVITY_EDITOR);
  const isCornucopiaPhaseOneEnabled = featureFlagService.is(featureKeys.CORNUCOPIA_PHASE_ONE);
  const activityPath = isActivityEditorEnabled && plugin.type === PLUGIN_TYPE_LESSON
    ? `/activity/${activityId}`
    : `/${plugin.type}/${activityId}`;

  if (isCornucopiaPhaseOneEnabled && plugin.pluginId === ETEXT_COURSE_PLUGIN_ID) {
    return await getCornucopiaScreenPath(activityId) ?? activityPath;
  }
  return activityPath;
};
